// @ts-strict
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Supabase configuration missing: VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
